<script setup lang="ts">
import { computed } from 'vue';
import RecordLink from '@/components/RecordLink.vue';
import { initialsOf } from '@/components/record/fields/formatFieldValue';

/** A person: an initials avatar, then their name, linked to their record. */
const props = defineProps<{ value: unknown }>();

const person = computed(() => {
    if (!props.value || typeof props.value !== 'object') {
        return null;
    }
    const record = props.value as Record<string, unknown>;
    const name = record.display_string ?? record.name;
    return {
        id: typeof record.id === 'number' || typeof record.id === 'string' ? record.id : null,
        name: typeof name === 'string' ? name : '',
    };
});
</script>

<template>
  <span v-if="person" class="inline-flex max-w-full min-w-0 items-center gap-2">
    <span
      class="inline-flex size-5 shrink-0 items-center justify-center rounded-full bg-muted text-[10px] font-semibold text-muted-foreground"
      aria-hidden="true"
      data-testid="person-avatar"
    >{{ initialsOf(person.name) }}</span>
    <RecordLink v-if="person.id !== null" entity-id="User" :record-id="person.id" :label="`User ${person.name}`">{{ person.name }}</RecordLink>
    <span v-else class="min-w-0">{{ person.name }}</span>
  </span>
</template>
